import React, { useEffect, useState } from "react";
import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { FaCheckCircle } from "react-icons/fa";
import { useGoal } from "./GoalContext";

const StyledContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 70vh;
  padding: 24px 16px;
  text-align: center;
`;

const StyledButton = styled(Button)`
  width: min(100%, 280px);
  min-height: 46px;
  font-size: 18px;
  border-radius: 999px;
`;

const StyledLink = styled(Link)`
  color: white;
  width: min(100%, 280px);

  &:hover {
    color: white;
    text-decoration: none;
  }
`;

const StyledCheckMark = styled(FaCheckCircle)`
  color: #2ab56f;
  font-size: 70px;
  margin: 12px 0 18px;
`;

const Lead = styled.p`
  max-width: 560px;
  font-size: 1rem;
  line-height: 1.9;
  color: #3d3d3d;
  margin-bottom: 12px;
`;

const Hint = styled.div`
  max-width: 560px;
  background: #fff8e8;
  border: 1px solid #f0d6a6;
  border-radius: 14px;
  padding: 14px 16px;
  margin: 8px 0 22px;
  color: #7b5b25;
  font-size: 0.95rem;
  line-height: 1.7;
`;

const PulseBox = styled.div`
  max-width: 560px;
  background: linear-gradient(135deg, #fff3d7 0%, #ffe8b0 100%);
  border: 1px solid #efcd7b;
  border-radius: 16px;
  padding: 16px 18px;
  margin: 0 0 18px;
  color: #6f511d;
  font-size: 0.98rem;
  font-weight: 700;
  line-height: 1.7;
`;

const RegisterComplete = () => {
  const { goalID } = useGoal();
  const [stage, setStage] = useState(0);

  useEffect(() => {
    const timers = [
      setTimeout(() => setStage(1), 900),
      setTimeout(() => setStage(2), 2600),
    ];
    return () => timers.forEach((timer) => clearTimeout(timer));
  }, []);

  const stageMessage = [
    "公開完了。あなたの夢の掲示板ができました。",
    "AIコメントは、自分の掲示板でON/OFFを選べます。",
    "そのまま掲示板へ行って、最初の一歩や本音を書いてみよう。",
  ][stage];

  return (
    <StyledContainer>
      <h2>無謀な夢を公開しました</h2>
      <StyledCheckMark />
      <Lead>
        夢の公開が完了しました。
        <br />
        掲示板で、次に試したいことを一つ残してみましょう。
      </Lead>
      <PulseBox>{stageMessage}</PulseBox>
      <Hint>
        最初の一歩や、いまの本音をひとこと書くと、
        <br />
        そのあとの会話が少し動きやすくなります。
      </Hint>
      <StyledLink to={`/boards/${goalID}`}>
        <StyledButton
          variant="primary"
          className="w-100 text-center d-flex align-items-center justify-content-center"
          style={{
            fontSize: "1.05rem",
            color: "#ffffff",
            borderColor: "transparent",
          }}
        >
          掲示板を見にいく
        </StyledButton>
      </StyledLink>
      <div style={{ height: "12px" }} />
      <StyledLink to="/">
        <StyledButton
          variant="outline-primary"
          className="w-100 text-center d-flex align-items-center justify-content-center"
          style={{ fontSize: "1rem" }}
        >
          トップに戻る
        </StyledButton>
      </StyledLink>
    </StyledContainer>
  );
};

export default RegisterComplete;
